import { createSlice } from '@reduxjs/toolkit'

//init slice
const _init = () =>{
    let pars = { cfgs: "" }       
    return pars;
}
export const apiSlice = createSlice ({
    name: "api",
    initialState: _init,
    reducers: {        
        setApiCfg: (state, action={}) => {
            state.cfgs = {...state.cfgs, ...action.payload}
        },        
    }    
})

export const apiActions = apiSlice.actions
export const apiReducer = apiSlice.reducer